import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Collapse, Table } from 'reactstrap';
import _ from 'lodash';
import { MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import { dateHelpers } from '../utils';

export default function ItemSite(props) {
   const ICONS = {
      collapseIcon: <MdOutlineExpandLess className="mobileToggle align-self-center" />,
      expandIcon: <MdOutlineExpandMore className="mobileToggle align-self-center" />
   }
   const [expanded, setExpanded] = useState(true);
   const [icon, setIcon] = useState(ICONS.collapseIcon);
   const [sites, setData] = useState([]);

   useEffect(() => {
      if (sites !== props.data) {
         setData(props.data)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props])

   function onClick() {
      // This is only so that the card is clickable and
      // can be used to toggle the accordian open/closed
      setExpanded(!expanded);
      if (expanded === true)
         setIcon(ICONS.expandIcon);
      else
         setIcon(ICONS.collapseIcon);
      props.onToggle();
   }

   return (
      <>
         {_.map(sites, (item, index) => {
            return (
               <div details={item} key={index} >
                  <Card id="toggler" className="py-0" onClick={onClick} style={{ cursor: "pointer" }}>
                     <CardBody className={(index % 2 === 0) ? "mobileGrayBg text-black my-0 py-2 px-2" : "mobileGrayBgAlt text-black my-0 py-2 px-2"}>
                        <CardTitle className={(index % 2 === 0) ? "mobileGrayBg text-black my-0 py-0 px-0" : "mobileGrayBgAlt text-black my-0 py-2 px-2"}>
                           {icon} {item.siteWithDescription}
                        </CardTitle>

                        <Collapse className="text-black" toggler="#toggler" isOpen={expanded}>
                           <Table borderless size="sm">
                              <tbody>
                                 <tr>
                                    <td className="data-cell my-0 py-0" width="35px">&nbsp;</td>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-black h6 fw-bold my-0">Bin #:</label>
                                       <label className="text-black h6 mx-1 my-0">{item.binNumber}</label>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 py-0">&nbsp;</td>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-black h6 fw-bold my-0">Qty On Hand:</label>
                                       <label className="text-black h6 mx-1 my-0">{item.qtyOnHand.toLocaleString("en-US", { maximumFractionDigits: 0 })}</label>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td className="data-cell my-0 py-0">&nbsp;</td>
                                    <td className="data-cell my-0 py-0">
                                       <label className="text-black h6 fw-bold my-0">Order Point Qty:</label>
                                       <label className="text-black h6 mx-1 my-0">{item.orderPoint.toLocaleString("en-US", { maximumFractionDigits: 0 })}</label>
                                    </td>
                                 </tr>
                                 {item.lastOrderDate ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">&nbsp;</td>
                                       <td className="data-cell my-0 py-0">
                                          <label className="text-black h6 fw-bold my-0">Last Order Date:</label>
                                          <label className="text-black h6 mx-1 my-0">{dateHelpers.dateTimeFormat(item.lastOrderDate, "MM-DD-YYYY")}</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                                 {item.lastOrderDate ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">&nbsp;</td>
                                       <td className="data-cell my-0 py-0">
                                          <label className="text-black h6 fw-bold my-0">Last Order Qty:</label>
                                          <label className="text-black h6 mx-1 my-0">{item.lastOrderQty.toLocaleString("en-US", { maximumFractionDigits: 0 })}</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                                 {item.lastRcptDate ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">&nbsp;</td>
                                       <td className="data-cell my-0 py-0">
                                          <label className="text-black h6 fw-bold my-0">Last Rcpt Date:</label>
                                          <label className="text-black h6 mx-1 my-0">{dateHelpers.dateTimeFormat(item.lastRcptDate, "MM-DD-YYYY")}</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                                 {item.lastRcptDate ?
                                    <tr>
                                       <td className="data-cell my-0 py-0">&nbsp;</td>
                                       <td className="data-cell my-0 py-0">
                                          <label className="text-black h6 fw-bold my-0 ">Last Rcpt Qty:</label>
                                          <label className="text-black h6 mx-1 my-0 ">{item.lastRcptQty.toLocaleString("en-US", { maximumFractionDigits: 0 })}</label>
                                       </td>
                                    </tr>
                                    : null
                                 }
                              </tbody>
                           </Table>
                        </Collapse>
                     </CardBody>
                  </Card>
               </div>
            )
         })}
      </>
   )
}
